/**
 * Návrat na původní adresu po přihlášení (hlavně odkaz z QR kódu na kartě vozu: /m/v/<id>).
 * Ukládá se jen vnitřní cesta aplikace a jen do této záložky (sessionStorage).
 */
const KEY = 'login_return_to';

const safe = (p: string | null | undefined): string | null =>
  p && p.startsWith('/') && !p.startsWith('//') && !p.startsWith('/login') ? p : null;

export function setReturnTo(path: string): void {
  try { const s = safe(path); if (s) sessionStorage.setItem(KEY, s); } catch { /* bez úložiště se jen přejde na úvodní stranu */ }
}
export function peekReturnTo(): string | null {
  try { return safe(sessionStorage.getItem(KEY)); } catch { return null; }
}
export function clearReturnTo(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* nevadí */ }
}
